import {Component, OnInit, TemplateRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MainService } from './main.service';
import { HttpClient } from '@angular/common/http';
import { Locale } from './models/Locale';
import { Menu } from './models/Menu';
import { Reservation } from './models/Reservation';
import { Department } from './models/Department';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MenuItem} from './models/MenuItem';
import {OrderModel} from './models/OrderModel';
import {Md5} from 'ts-md5/dist/md5';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Coupon} from './models/Coupon';
import {ToastrService} from 'ngx-toastr';
import {TimeSlot} from './models/TimeSlot';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import { Injectable } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';
import {TimeSlotResponse} from './models/TimeSlotResponse';

@Injectable({
  providedIn: 'root'
})

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {

    private window;
    reservationPaymentModalRef?: BsModalRef;
    privacyModalRef?: BsModalRef;
    orderCouponRef?: BsModalRef;
    minReservationDate: Date;
    maxReservationDate: Date;

    constructor(
            private http: HttpClient,
            private route: ActivatedRoute,
            public translate: TranslateService,
            private _http: MainService,
            private modalService: BsModalService,
            private toastr: ToastrService,
            private _localeService: BsLocaleService,
            private _windowRef: WindowReferenceService
            ) {
                translate.addLangs(['en', 'pl', 'ru', 'ua']);
                translate.setDefaultLang('en');
                const browserLang = translate.getBrowserLang();
                translate.use(browserLang.match(/en|pl|ru|ua/) ? browserLang : 'en');
                this.minReservationDate = new Date();
                this.minReservationDate.setDate(this.minReservationDate.getDate());
                this.maxReservationDate = new Date();

                if (browserLang === 'pl') {
                  this._localeService.use('pl');
                } else {
                  this._localeService.use('en');
                }

                this.window = _windowRef.nativeWindow;
            }

    phoneForm = new FormGroup({
        phone: new FormControl(undefined, [Validators.required])
    });
    phoneOrderForm = new FormGroup({
      phone: new FormControl(undefined, [Validators.required])
    });
    public locale_code;
    public sellway_token = '';
    private userLanguage;
    public localeModel: Locale;
    public menuModel: Menu;
    public reservationModel: Reservation;
    public department: Department;
    style_background = '';
    next_step = false;
    step = 1;
    public personsList = null;
    // public aviable_reservations_list = null;
    public reservationSlotLimit = 0;
    public time_active = 0;
    public menuTab = false;
    public requestInProcess = false;
    public menuRequestInProgress = false;
    privacyDeliveryHandlerOpenedStyle: string;
    privacyDeliveryButtonCloseStyle: string;
    termsHandlerOpenedStyle: string;
    termsButtonCloseStyle: string;
    reservationDaysDisabled: [0,6];
    reservationTimeSlots: TimeSlot[];
    reservationTimeSlotsMessageCode: number;
    public reservationPaymentInProgress = false;
    public reservationPaymentCompleted = false;
    public reservationPaymentCompletedStatus = 4;


    disabledDates = [

    ];

    // Orders
    public menuHandlerOpenedStyle: string;
    public menuButtonCloseStyle: string;
    public cartHandlerOpenedStyle: string;
    public cartButtonCloseStyle: string;
    public activeMenuItem: MenuItem;
    public activePositionCount = 1;
    public activePositionCost: any;
    public cart = [];
    public cartPossibleCounts = Array.from({length: 20}, (_, i) => i + 1);
    public cartStep = 0; // 0 = cart; 1 = checkout; 2 = finish
    public orderModel: OrderModel;
    public orderScheduledNowDate;
    public orderScheduledMinDate;
    public orderProcessing = false;
    public orderPlacedId = 0;
    public isDateAvailableForOrder = true;
    public timesAvailableForDate = [];
    public justAddedtoCartAnimation = false;
    public couponCode: string;
    public couponTmp: Coupon;
    public coupon: Coupon;
    public errorMsgShow: boolean;
    public errorLowPriceMsgShow: boolean;


    can_finish = function (f) {
        if (this.reservationModel.name && this.reservationModel.email && !f.form.controls['phone'].invalid) {
            return true;
        }
        return false;
    };

    ngOnInit(): void {
        // Get locale code from URL
        this.userLanguage = navigator.language.split('-')[0];
        this.locale_code = location.search.split('cn=')[1];
        this.sellway_token = location.search.split('sellway_token=')[1];

        this.reservationModel = new Reservation();
        this.reservationModel.phone = '';
        this.reservationModel.persons = 0;
        this.reservationModel.reservationData = 0;
        this.reservationModel.department = null;
        this.reservationModel.language = this.userLanguage;
        if (this.sellway_token !== undefined) {
          this.reservationModel.sellway_token = this.sellway_token;
        }

        const urlParams = new URLSearchParams(location.search);
        const sourceParam = urlParams.get('source');
        if (sourceParam) {
          this.reservationModel.source = sourceParam;
        }

        this.localeModel = new Locale();
        this.localeModel.menuToken = '';

        if (this.locale_code) {
            this._http.getLocale(this.locale_code, this.userLanguage).subscribe(
                data => this.localeModel = data,
                error => console.log(error),
                () => this.processLocale()
            );
        }

        this.setupReservationCalendar();
    }

    public setupReservationCalendar () {
      //TODO: ADD BLOCKDAYS AND BLOCKDATES

      // this.dpConfig.showWeekNumbers = false;
      // this.dpConfig.dateInputFormat = 'Do MMMM YYYY';
      // this.dpConfig.isAnimated = true;
      // this.minReservationDate = new Date();
      // this.minReservationDate.setDate(this.minReservationDate.getDate());
      //
      // this.reservationDaysDisabled = [0,6];
      // this.reservationDatesDisabled = [
      //   new Date('2021-08-20')
      // ]
    }


    openCouponModal (template) {
      this.orderCouponRef = this.modalService.show(template);
    }

    /**
     * Get locale information
     */
    processLocale () {
        this.orderModel = new OrderModel();
        this.processOrderModel();
        if (this.localeModel.widget_side_img === '1') {
          this.style_background = 'url(' + this.localeModel.photo + ') no-repeat scroll 85px #ffffff';
        } else {
          this.style_background = 'none;';
        }
        this.reservationModel.code = this.localeModel.code;
        this.personsList = this.localeModel.personsList;
        if (this.localeModel.departments.length === 1) {
            this.reservationModel.department = this.localeModel.departments[0];
            this.orderModel.department = this.localeModel.departments[0];
            this.changeDepartment();
        } else {
          this.orderModel.department = null;
        }
        if (this.localeModel.menuToken) {
            this.loadMenu();
        }
    }

    checkAvailableTimesTimes () {
      if (this.reservationModel.reservationData && this.reservationModel.persons) {
        this.next_step = false;
        this.time_active = -1;
        this.reservationModel.time = null;

        this._http.getTimeSlots(
          this.reservationModel.department.id,
          this.getHumanReservationDate(),
          this.reservationModel.persons,
          this.reservationModel.preferred_hall_id,
          this.reservationModel.duration_id
        ).subscribe(
            data => {
              this.reservationTimeSlots = data.TimeSlot;
              this.reservationTimeSlotsMessageCode = data.msg_code
            },
            error => console.log(error),
            () => {
              this.checkIfPaymentRequired();
            }
          );
      }
    }

    checkIfPaymentRequired () {
      this._http.getPaymentInfo(
        this.reservationModel.department.id,
        this.getHumanReservationDate(),
        this.reservationModel.persons,
        null,
        null,
        this.reservationModel.preferred_hall_id || null
      ).subscribe(
        data => {
          // @ts-ignore
          if (data.value  > 0) {
            this.reservationModel.department.payment_required = true;
            // @ts-ignore
            this.reservationModel.department.payment_val = data.value;
          } else {
            this.reservationModel.department.payment_required = false;
            this.reservationModel.department.payment_val = 0;
          }
        },
        error => console.log(error),
        () => {console.log(this.reservationModel)}
      );
    }

    openLinkInNewTab(url) {
      this.reservationPaymentInProgress = true;
      window.open(url, '_blank').focus();
      this.checkReservationStatus();
    }

    checkReservationStatus () {
      var self = this;
      var sub = window.setInterval(function(){
        self._http.getReservationStatus(self.reservationModel.code).subscribe(
          data => {
            if (data['status'] !== 4) {
              clearInterval(sub);
              self.reservationPaymentInProgress = false;
              self.reservationPaymentCompleted = true;
              self.reservationPaymentCompletedStatus = data['status'];
            }
          },
          error => self._showError(error),
          () => {  }
        );

      }, 5000);
    }

    processOrderModel () {
      this.orderModel.deliveryOption = null;
      this.orderModel.isScheduled = null;
      this.orderModel.scheduledTimeVal = null;
      this.orderModel.paymentMethod = null;
      this.orderModel.needInvoice = false;
      this.orderModel.agreement = false;
      this.orderModel.privacy_agreement = false;
      this.orderModel.status = 0;

      const today = new Date();
      this.orderScheduledNowDate = today.toISOString().split('T')[0];
      this.orderScheduledMinDate = new Date().toISOString().split('T')[0];
    }


    /**
     * Load menu
     */
    loadMenu(menuTab = false) {
        this.menuRequestInProgress = true;
        this.menuTab = menuTab;
        if (!this.menuModel) {
            this._http.getMenu(this.localeModel.menuToken).subscribe(
                data => this.menuModel = data,
                error => {
                    console.log(error);
                    this.menuRequestInProgress = false;
                  },
                () => {
                    this.menuRequestInProgress = false;
                  },
            );
        }
    }

    /**
     * Process reservation
     */
    sendReservation() {
        if (!this.validateEmail(this.reservationModel.email)) {
          this.toastr.error(this.translate.instant('BOOK.WRONG_EMAIL'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }

        this.requestInProcess = true;

        //GTM Script
        if(typeof this.window.sendReservation !== 'undefined') {
          this.window.sendReservation(this.reservationModel.phone.number, this.reservationModel.email);
        }

        this._http.sendReservation(this.reservationModel).subscribe(
            data => {
                if (data['status'] === 500) {
                    this.toastr.error(this.translate.instant('BOOK.SERVER_ERROR'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
                    return this.processError();
                } else if (data['status'] === 400) {
                    this.toastr.error(this.translate.instant('BOOK.WRONG_PHONE'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
                    return this.processError();
                } else {
                    this.reservationModel.reservation_code = data.reservation_code;
                    this.reservationModel.reservation_status = data.reservation_status;
                    this.reservationModel.payment_url = data.payment_url;
                    this.reservationModel.code = data.code;
                    this.processReservationResponse();
                }
            },
            error => {
              this.toastr.error(this.translate.instant('BOOK.WRONG_RESERVATION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            },
            () => false
        );
    }

    processReservationResponse () {
        this.step = 3;
        this.requestInProcess = false;
    }

    processError() {
        this.step = 2;
        this.requestInProcess = false;
        return true;
    }

    changeDepartment() {
        this.reservationModel.persons = 0;
        this.reservationModel.reservationData = 0;
        this.reservationModel.preferred_hall_id = 0;
        if (this.reservationModel.department) {
            this._http.getDepartment(this.reservationModel.department.id, 0).subscribe(
                data => this.department = data,
                error => console.log(error),
                () => this.processDepartment(),
            );
        }
    }

    processDepartment () {
        this.personsList = this.department.personsList;
        // this.aviable_reservations_list = this.department.reservationList;
        this.reservationSlotLimit = this.department.reservationSlotLimit;
        if (this.department.durationOptions[0]) {
          // @ts-ignore
          this.reservationModel.duration_id = this.department.durationOptions[0].id;
        }

        if (this.department.maxDaysInReservationCalendar > 0) {
          this.maxReservationDate.setDate(this.maxReservationDate.getDate() + this.department.maxDaysInReservationCalendar);
        }


        return;
    }

    unsetDepartment () {
        this.department = null;
        this.personsList = 0;
        this.step = 1;
        this.next_step = false;
    }

    cleanReservation () {
      this.reservationModel = new Reservation();
      this.reservationModel.phone = '';
      this.reservationModel.persons = 0;
      this.reservationModel.reservationData = 0;
      this.reservationModel.department = null;
      this.reservationModel.language = this.userLanguage;

      this.processLocale();

      this.step = 1;
      this.personsList = 0;
      this.next_step = false;
    }

    validateEmail (email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    showPrivacy (template: TemplateRef<any>) {
      this.privacyModalRef = this.modalService.show(template);
    }

    showDeliveryPrivacy (show = true) {
      if (show) {
        this.privacyDeliveryHandlerOpenedStyle = 'handler-opened';
        this.privacyDeliveryButtonCloseStyle = 'make-close';
      } else {
        this.privacyDeliveryHandlerOpenedStyle = '';
        this.privacyDeliveryButtonCloseStyle = '';
      }
    }
    showDeliveryTerms (show = true) {
      if (show) {
        this.termsHandlerOpenedStyle = 'handler-opened';
        this.termsButtonCloseStyle = 'make-close';
      } else {
        this.termsHandlerOpenedStyle = '';
        this.termsButtonCloseStyle = '';
      }
    }
    showReservationPaymentRegulamin (template: TemplateRef<any>) {
      this.reservationPaymentModalRef = this.modalService.show(template);
    }

  setReservationDuration(option) {
    this.reservationModel.duration_id = option.id;
    this.checkAvailableTimesTimes();
  }
  processTimeClick (time, index) {
    if (time.available) {
      this.time_active = index;
      this.next_step = true;
      this.reservationModel.time = time.time;
    }
  }
  getTranslation (text) {
    return this.translate.instant(text);
  }
  menuGetShortTitle (name) {
    if (name.length > 35) {
      return name.substring(0, 35) + '...';
    }
    return name;
  }
  menuGetShortDescription (description) {
    if (description.length > 35) {
      return description.substring(0, 35) + '...';
    }
    return description;
  }
  showItemInfo (show, menuItem) {
    if (show) {
      this.activeMenuItem = menuItem;
      this.activePositionCount = 1;
      this.activePositionCost = this.activePositionCount * this.activeMenuItem.price;
      this.menuHandlerOpenedStyle = 'handler-opened';
      this.menuButtonCloseStyle = 'make-close';
    } else {
      this.activeMenuItem = null;
      this.menuHandlerOpenedStyle = '';
      this.menuButtonCloseStyle = '';
    }
  }
  increaseActivePositionCount () {
    this.activePositionCount++;
    this.activePositionCost = this.getTotalItemPrice(this.activePositionCount, this.activeMenuItem.price);
  }
  decreaseActivePositionCount () {
    if (this.activePositionCount > 1) {
      this.activePositionCount--;
      this.activePositionCost = this.getTotalItemPrice(this.activePositionCount, this.activeMenuItem.price);
    }
  }
  getTotalItemPrice (cost, quantity) {
    return (cost * quantity).toFixed(2);
  }
  addItemToCart(item, count = null, price = null) {
    this.justAddedtoCartAnimation = true;
    setTimeout(() => {  this.justAddedtoCartAnimation = false; }, 500);


    const cartItem = {
      itemId: item.id,
      item: item,
      quantity: count ? count : this.activePositionCount,
      price: price ? price : this.activeMenuItem.price
    };

    const index = this.cart.findIndex(function(o) {
      if (o.itemId === cartItem.itemId) {
        return true;
      }
    });

    // tslint:disable-next-line:comment-format
    //Detect if itim is already in cart. In case if it is already exists we need to add only quantity
    if (index >= 0) {
      this.cart[index].quantity = this.cart[index].quantity + (count ? count : this.activePositionCount);
    } else {
      this.cart.push(cartItem);
    }

    this.showItemInfo(false, null);
  }
  showCart(shouldOpen) {
    this.cartStep = 0;
    if (shouldOpen) {
      this.cartHandlerOpenedStyle = 'handler-opened';
      this.cartButtonCloseStyle = 'make-close';
    } else {
      this.cartHandlerOpenedStyle = '';
      this.cartButtonCloseStyle = '';
    }
  }
  amount(item) {
    return item.price * item.quantity;
  }
  sum(prev, next) {
    return prev + next;
  }
  getCartTotal () {
    if (this.cart.length === 0) {
      return 0;
    }
    return this.cart.map(this.amount).reduce(this.sum).toFixed(2);
  }
  countDelivery () {
    const cartTotal = this.getCartTotal();
    const deliveryCost = parseFloat(String(this.orderModel.department.delivery_cost));
    const freeDeliveryFrom = parseFloat(String(this.orderModel.department.free_delivery_from));
    if (this.orderModel.deliveryOption === 'PICKUP') {
      return 0.00;
    }
    if (deliveryCost > 0 && cartTotal < freeDeliveryFrom) {
      return parseFloat(String(deliveryCost)).toFixed(2);
    }
    return 0.00;
  }
  getFinalTotal(withoutCoupon = true) {
    const cartTotalCost = this.getCartTotal();
    const deliveryCost = this.countDelivery();

    // tslint:disable-next-line:max-line-length
    if (!withoutCoupon && this.coupon && this.coupon.name) {
      if (this.coupon.type == 'PERSENTAGE') {
        return (parseFloat(<string>cartTotalCost) * (1 - (this.coupon.value / 100))).toFixed(2);
      } else {
        return (parseFloat(<string>cartTotalCost) - this.coupon.value).toFixed(2);
      }
    }
    return (parseFloat(<string>cartTotalCost) + parseFloat(<string>deliveryCost)).toFixed(2);
  }
  deleteFromCart (cartItem) {
    const index = this.cart.findIndex(function(o) {
      if (o.itemId === cartItem.itemId && o.quantity === cartItem.quantity) {
        return true;
      }
    });
    if (index !== -1) {
      this.cart.splice(index, 1);
    }

    if (this.cart.length < 1) {
      this.showCart(false);
    }
  }

  /**
   * 0 - Cart table
   * 1 - Form data
   * 2 - Confirmation
   * 3 - Result
   */
  cartNextStep() {
    if (this.cartStep === 0 && !this.orderModel.department) {
      this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_LOCATION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    if (this.cartStep === 0 && this.getCartTotal() < parseFloat(String(this.orderModel.department.minimal_delivery_cost))) {
      const text = this.translate.instant('MENU.ORDER_FORM_ALERT_MINIMAL_DELIVERY') + ' '
        + this.orderModel.department.minimal_delivery_cost + ' '
        + this.translate.instant('MENU.currency');
      this.toastr.error(text, '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    if (this.cartStep === 1) {
      if (!this.orderModel.department) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_LOCATION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.deliveryOption) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TYPE'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.isScheduled) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TIME_OPTION'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      // tslint:disable-next-line:radix
      if (this.orderModel.isScheduled === 'SCHEDULED' && !this.orderModel.scheduledDateVal) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TIME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.orderModel.isScheduled === 'SCHEDULED' && !this.orderModel.scheduledTimeVal) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_TIME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.paymentMethod) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_PAYMENT_METHOD'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.orderModel.deliveryOption === 'DELIVERY' && !this.orderModel.deliveryAddress) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_DELIVERY_ADDRESS'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (!this.orderModel.name) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_NAME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.isNeedToAskPhoneNumber()) {
        if (this.phoneOrderForm.controls['phone'].invalid) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_PHONE'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
      }
      if (!this.orderModel.email || !this.validateEmail(this.orderModel.email)) {
        this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_EMAIL'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        return;
      }
      if (this.orderModel.needInvoice) {
        if (!this.orderModel.companyName) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_COMPANY_NAME'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
        if (!this.orderModel.companyAddress) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_COMPANY_ADDRESS'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
        if (!this.orderModel.companyNip) {
          this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_COMPANY_NIP'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
          return;
        }
      }
    }
    this.cartStep++;
  }
  cartPrevStep() {
    this.cartStep--;
  }
  needInvoiceCheckbox () {
    this.orderModel.needInvoice = !this.orderModel.needInvoice;
  }
  agreementCheckbox() {
    this.orderModel.agreement = !this.orderModel.agreement;
  }
  privacyDeliveryAgreement () {
    this.orderModel.privacy_agreement = !this.orderModel.privacy_agreement;
  }
  processOrder() {
    if (!this.orderModel.agreement) {
      this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_AGREEMENT'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    if (!this.orderModel.privacy_agreement) {
      this.toastr.error(this.translate.instant('MENU.ORDER_FORM_ALERT_AGREEMENT'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
      return;
    }
    this.orderProcessing = true;
    this.orderModel.cart = this.cart;
    const md5 = new Md5();
    this.orderModel.timeAdded = Date.now().toString();
    this.orderModel.checksum = md5.appendStr(this.orderModel.timeAdded + this.localeModel.id + this.orderModel.email).end().toString();
    this.menuRequestInProgress = true;
    // tslint:disable-next-line:max-line-length
    if (this.coupon && this.coupon.name) {
      this.orderModel.coupon_id = this.coupon.id;
      this.orderModel.coupon_name = this.coupon.name;
    }
    this._http.sendOrder(this.orderModel).subscribe(
      data => {
        this.orderPlacedId = data.order_id;
        this.orderPlaced();
      },
      error => {
        this.menuRequestInProgress = false;
        this.toastr.error(this.translate.instant('MENU.ORDER_PLACE_ERROR'), '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
        this.orderProcessing = false;
      },
      () => {
        this.menuRequestInProgress = false;
      }
    );
  }
  orderPlaced() {
    this.orderProcessing = false;
    this.cartStep = 3;
  }
  clearOrder() {
    this.showCart(false);
    this.orderModel = new OrderModel();
    this.processOrderModel();
    this.cart = [];
  }

  applyCoupon() {
    this.errorLowPriceMsgShow = false;
    this._http.getCoupon(this.localeModel.id, this.couponCode).subscribe(
      data => { this.couponTmp = data; },
      error => this._showError(error),
      () => { this._checkCoupon(); }
    );
  }

  _showError(error) {
    this.errorMsgShow = true;
  }

  _checkCoupon () {
    if (this.couponTmp) {
      if (this.couponTmp.minimum_order_sum && this.getCartTotal() < this.couponTmp.minimum_order_sum) {
        this.errorLowPriceMsgShow = true;
      } else {
        this.coupon = this.couponTmp;
        this.orderCouponRef.hide();
      }
    }
  }

  checkOrderDate (date = null) {
    this.isDateAvailableForOrder = true;
    let response = '';
    if (this.orderModel.isScheduled === 'ASAP') {
      this._http.getOrderDatesAvailable(this.orderModel.department.id).subscribe(
        data => response = data,
        error => console.log(error),
        () => {
          // @ts-ignore
          if (response.is_day_off == 1 || response.hour_now < response.opens_at || response.hour_now >= response.closes_at) {
            this.isDateAvailableForOrder = false;
            return;
          } else {
            this.isDateAvailableForOrder = true;
            return;
          }
        }
      );
      return;
    } else if (this.orderModel.isScheduled === 'SCHEDULED' && date) {
      this._http.getOrderDatesAvailable(this.orderModel.department.id, date).subscribe(
        data => response = data,
        error => console.log(error),
        () => {
          // @ts-ignore
          if (response.is_day_off == 1) {
            this.toastr.error('Przepraszamy. Nie przyjmujemy zamówień w tym dniu (' + date + '). Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            this.isDateAvailableForOrder = false;
            return;
          }
          const isToday = date == new Date().toISOString().split('T')[0];
          // @ts-ignore
          if (isToday && response.hour_now >= response.closes_at) {
            this.toastr.error('Przepraszamy. Nie przyjmujemy już zamówień w tym dniu. Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
            this.isDateAvailableForOrder = false;
            return;
          }
          // @ts-ignore
          if (isToday && response.hour_now >= response.opens_at) {
            // @ts-ignore
            this.prepareTimeAvailableSelector(response.hour_now + 1, response.closes_at);
            if (this.timesAvailableForDate.length === 0) {
              this.toastr.error('Przepraszamy. Nie przyjmujemy już zamówień w tym dniu. Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
              this.isDateAvailableForOrder = false;
              return;
            }
          } else {
            // @ts-ignore
            this.prepareTimeAvailableSelector(response.opens_at, response.closes_at);
            if (this.timesAvailableForDate.length === 0) {
              this.toastr.error('Przepraszamy. Nie przyjmujemy już zamówień w tym dniu. Wybierz inną datę.', '', {timeOut: 3000, positionClass: 'toast-top-right', closeButton: true, tapToDismiss: true});
              this.isDateAvailableForOrder = false;
              return;
            }
          }
          this.isDateAvailableForOrder = true;
          return;
        }
      );
      return;
    }
  }

  prepareTimeAvailableSelector (startTime, endTime) {
    const times = [];
    for (let step = startTime; step < endTime; step++) {
      times.push(step + ':00');
      times.push(step + ':30');
    }
    this.timesAvailableForDate = times;
  }
  isNeedToAskPhoneNumber () {
    return (this.orderModel.department.delivery_delivery_phone > 0 && this.orderModel.deliveryOption === 'DELIVERY') ||
      (this.orderModel.department.delivery_pickup_phone > 0 && this.orderModel.deliveryOption === 'PICKUP');
  }
  getHumanReservationDate () {
    if (this.reservationModel.reservationData) {
      let d = this.reservationModel.reservationData.getDate();
      let m = this.reservationModel.reservationData.getMonth() + 1; //Month from 0 to 11
      let y = this.reservationModel.reservationData.getFullYear();
      return '' + (d <= 9 ? '0' + d : d) + '.' + (m<=9 ? '0' + m : m) + '.' + y;
    }

    return '';
  }

}





